<template>
	<ul :class="$style['dropdown-menu-list']">
		<template v-for="(item, index) in list">
			<DropdownMenuItem
				v-if="!item.spacer"
				:key="item.title"
				:item="item"
				@dropdown-toggle="$emit('dropdown-toggle', $event)"
			/>
			<BaseHr
				v-else
				:key="'hr' + index"
			/>
		</template>
	</ul>
</template>
<script>
import DropdownMenuItem from './DropdownMenuItem'
export default {
	name: 'DropdownMenuList',
	components: {
		DropdownMenuItem
	},
	props: {
		list: {
			type: Array,
			required: true
		}
	}
}
</script>
<style lang="scss" module>
.dropdown-menu-list {
		list-style: none;
		padding: 0;
		margin: 0;
		max-height: 400px;
		overflow: auto;
	}
</style>
